"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var _icons = require("../../assets/icons");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
var InputSelect = function(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Select, _extends({}, props, {
        style: {
            color: "#000 !important",
            label: {
                color: "#000000",
                fontWeight: 400,
                marginBottom: 8
            },
            input: {
                "&[data-invalid]": {
                    borderColor: "red"
                }
            },
            item: {
                // applies styles to selected item
                "&[data-selected]": {
                    "&, &:hover": {
                        backgroundColor: "#e2ccff",
                        color: "#000000"
                    }
                },
                // applies styles to hovered item (with mouse or keyboard)
                "&[data-hovered]": {
                    "&, &:hover": {
                        backgroundColor: "#e2ccff",
                        color: "#000000"
                    }
                }
            }
        },
        role: "none",
        styles: _extends({}, props.styles ? props.styles : {}),
        rightSection: /*#__PURE__*/ (0, _jsxruntime.jsx)(_icons.ArrowDown, {})
    }));
};
var _default = InputSelect;
